import styled from 'styled-components';
import React from 'react';
import CustomSpan from 'components/common/text/CustomSpan';
import { T } from 'components/common/text';
import { IconButton } from '@material-ui/core';
import TrashIcon from 'components/base/icons/TrashIcon';
import { TDeletePeriod } from 'containers/user/CloudManagementModalContainer';

interface CloudSimpleRemoveProps {
  onClikcPeriodDelete: (type: TDeletePeriod) => void;
}

const CloudSimpleRemove = ({ onClikcPeriodDelete }: CloudSimpleRemoveProps) => {
  return (
    <StyledCloudSimpleRemove data-component-name="CloudSimpleRemove">
      <div className="cloudSimpleRemove__title">
        <CustomSpan fontSize={18} fontWeight={600}>
          <T>DATA_SIMPLE_MANAGE</T>
        </CustomSpan>
      </div>
      <div className="cloudSimpleRemove__button_box">
        <IconButton
          className="cloudSimpleRemove__button"
          onClick={() => {
            onClikcPeriodDelete('15');
          }}
        >
          <CustomSpan fontSize={16} fontColor={'#444'}>
            <T>DATA_KEEP_LAST_SHORT_DAYS</T>
          </CustomSpan>
          <TrashIcon width={20} />
        </IconButton>
        <IconButton
          className="cloudSimpleRemove__button"
          onClick={() => {
            onClikcPeriodDelete('30');
          }}
        >
          <CustomSpan fontSize={16} fontColor={'#444'}>
            <T>DATA_KEEP_LAST_MIDDLE_DAYS</T>
          </CustomSpan>
          <TrashIcon width={20} />
        </IconButton>
        <IconButton
          className="cloudSimpleRemove__button"
          onClick={() => {
            onClikcPeriodDelete('90');
          }}
        >
          <CustomSpan fontSize={16} fontColor={'#444'}>
            <T>DATA_KEEP_LAST_LONG_DAYS</T>
          </CustomSpan>
          <TrashIcon width={20} />
        </IconButton>
      </div>
    </StyledCloudSimpleRemove>
  );
};

const StyledCloudSimpleRemove = styled.div<{}>`
  width: 100%;
  padding: 30px;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  .cloudSimpleRemove__button_box {
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    .cloudSimpleRemove__button {
      width: 100%;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid #e1e1e7;
    }
  }
`;

export default CloudSimpleRemove;
